import { Button, Link } from 'react-admin'
import UploadIcon from '@mui/icons-material/Upload'
import { usePreview } from '../../hooks/usePreview'
import { ImportButtonProps } from './type'

export const ImportButton: React.FC<ImportButtonProps> = ({
  to = '',
  label,
  icon = <UploadIcon />,
  ...props
}): JSX.Element => {
  const { previewPath } = usePreview()
  return (
    <Link to={to ? to : previewPath}>
      <Button size='medium' startIcon={icon} label={label} {...props}>
        {icon}
      </Button>
    </Link>
  )
}
